import { render, staticRenderFns } from "./ChatStickerV2.vue?vue&type=template&id=623c62da&scoped=true"
import script from "./ChatStickerV2.vue?vue&type=script&lang=js"
export * from "./ChatStickerV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623c62da",
  null
  
)

export default component.exports